import { stringify } from 'qs';
import { getValidUrl, parseQuery } from '@betgames/bg-tools';
import { IBGParams, IPartnerPageQueryParams } from '@bg-shared/integrations/shared/interfaces';
import { getDomain } from './getDomain';

export const getSource = (params: IBGParams, newIntegration: boolean): string => {
    const queryParams = parseQuery<IPartnerPageQueryParams>(window.location.search);

    const apiUrl = getValidUrl(params.apiUrl || params.server);
    let clientUrl;

    if (params.clientUrl || params.client) {
        clientUrl = getValidUrl(params.clientUrl || params.client);
    } else {
        clientUrl = getValidUrl(`webiframe.${getDomain(apiUrl)}`);
        console.warn(
            'Please provide new "client" parameter and use new integration, for more information contact BetGames.TV integrations / support',
        );
    }

    const query = stringify({
        ...(apiUrl && { apiUrl }),
        partnerUrl: params.partnerUrl || window.location.href,
        partnerCode: params.partnerCode || params.partner,
        token: params.token || params.partnerToken,
        locale: params.locale || params.language,
        timezone: params.timezone,
        oddsFormat: params.oddsFormat || params.odds_format,
        defaultPage: queryParams.bgpage || params.defaultPage,
        gameId: queryParams.bggame || params.gameId || params.defaultGame || params.current_game,
        homeUrl: params.homeUrl || params.home_url,
        singleGame: params.singleGame,
        bettingAmounts: params.bettingAmounts ? JSON.stringify(params.bettingAmounts) : undefined,
        themeEditor: params.themeEditor,
        onlyGUI: params.onlyGUI,
        defaultGUI: params.defaultGUI,
        dateTimeFormat: params.dateTimeFormat,
        wsUrl: params.wsUrl,
        newIntegration: Number(newIntegration),
        scriptIntegration: 1,
        lobbyLiveGames: params?.lobbyLiveGames || 0,
        lobbyDefaultTab: params?.lobbyDefaultTab || 0,
        rgsToken: params.rgsParams?.token,
        rgsLogin: params.rgsParams?.login,
    });

    return `${clientUrl}/auth?${query}`;
};
